// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var $dot$dot = require("..");
var Caml_option = require("bs-platform/lib/js/caml_option.js");

function toOption(maybe) {
  return $dot$dot.foldMaybe(undefined, (function (justValue) {
                return Caml_option.some(justValue);
              }), maybe);
}

exports.toOption = toOption;
/* .. Not a pure module */



//////////////////
// WEBPACK FOOTER
// ../xod-func-tools/src/Maybe.bs.js
// module id = 254
// module chunks = 0